import { VIRTUAL_SCROLL_STRATEGY } from '@angular/cdk/scrolling';
import { Directive, forwardRef, Input } from '@angular/core';
import { PhxSelectOption } from '../select.types';
import { PhxCustomVirtualScrollStrategy } from './phx-custom-scroll-strategy';
import { PhxHeightPredictorFn } from '../select.types';

export function scrollStrategyFactory(directive: PhxCustomVirtualScrollDirective) {
  return directive.scrollStrategy;
}

@Directive({
  selector: '[phxCustomVirtualScroll]',
  providers: [
    {
      provide: VIRTUAL_SCROLL_STRATEGY,
      useFactory: scrollStrategyFactory,
      deps: [forwardRef(() => PhxCustomVirtualScrollDirective)],
    },
  ],
})
export class PhxCustomVirtualScrollDirective {
  scrollStrategy = new PhxCustomVirtualScrollStrategy();

  private _options: PhxSelectOption[] = [];
  private _heightPredictor!: PhxHeightPredictorFn;

  @Input()
  set phxOptions(value: PhxSelectOption[] | null) {
    this._options = value || [];
    this.scrollStrategy.updateOptions(this._options);
  }
  @Input()
  set phxCustomHeightPredictor(predictor: PhxHeightPredictorFn) {
    if (predictor) {
      this._heightPredictor = predictor;
      this.scrollStrategy.updateHeightPredictor(this._heightPredictor);
    }
  }
}
